import { Button, Form, Input, Modal, notification, Table } from "antd"
import { useEffect, useState } from "react"
import { createAdmin, deleteAdmin, listAdmins, modifyAdmin } from "../../api"
import { Admin } from "../../interfaces/Admin"
import './index.css'
const OauthConfig = () => {
    const [isOpenModal, setisOpenModal] = useState(false)
    const [isAdd, setisAdd] = useState(false)
    const [data, setData] = useState<Admin[]>()
    const [api, contextHolder] = notification.useNotification();
    const [form] = Form.useForm()

    const columns = [
        {
            title: "oauth id",
            dataIndex: "oauthId",
        },
        {
            title: "名称",
            dataIndex: "name"
        },
        {
            title: "操作",
            render: (res: any) => {
                return (
                    <div className="option_group">
                        <Button type="primary" onClick={() => handleClick(res)}>编辑</Button>
                        <Button type="primary" danger onClick={() => handleDelete(res)}>删除</Button>
                    </div>
                )
            }
        }
    ]

    const getConfigs = async () => {
        const {data} = await listAdmins()
        setData(data)
    }

    const handleClick = (columnData: Admin) => {
        const deepCloneData = JSON.parse(JSON.stringify(columnData))
        form.setFieldsValue(deepCloneData)
        setisAdd(false)
        setisOpenModal(!isOpenModal)
    }

    const handleDelete = (columnData: Admin) => {
        Modal.confirm({
            title: '删除',
            content: '确定删除该人员吗？',
            okText: '确定',
            cancelText: '取消',
            onOk: async () => {
                const { status } = await deleteAdmin(columnData)
                if (status == 204) {
                    api.success({
                        message: `删除人员成功！`,
                        placement: 'top',
                    });
                } else {
                    api.error({
                        message: `删除人员失败！`,
                        placement: 'top',
                    });
                }
                getConfigs()
            }
        });
    }

    const handleAdd=()=>{
        form.resetFields()
        setisAdd(true)
        setisOpenModal(!isOpenModal)
    }

    const handleOk = async () => {
        let adminConfig
        try {
         adminConfig = await form.validateFields()
        } catch (error) {
            api.error({
                message: `请填写完整信息！`,
                placement: 'top',
            })
            return
        }
        const { status } = isAdd? await createAdmin(adminConfig) :await modifyAdmin(adminConfig)
        if (status == 200) {
            api.success({
                message: `修改人员成功！`,
                placement: 'top',
            });
        } else {
            api.error({
                message: `修改人员失败！`,
                placement: 'top',
            });
        }
        setisOpenModal(!isOpenModal)
        getConfigs()
    }
    useEffect(() => { getConfigs() }, [])
    return <div>
        {contextHolder}
        <Button className="add_button" type="primary" onClick={handleAdd}>新增</Button>
        <Table rowKey={'oauthId'} columns={columns} dataSource={data} pagination={{hideOnSinglePage :true}} />
        <Modal
            title={isAdd ? "新增" : "编辑"}
            open={isOpenModal}
            onOk={handleOk}
            onCancel={() => setisOpenModal(!isOpenModal)}
        >
            <Form
                form={form}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
                labelAlign="left"

            >
                <Form.Item<Admin>
                    label="oauth id："
                    name="oauthId"
                    rules={[{ required: true, message: "请输入 oauth id" }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item<Admin>
                    label="名称："
                    name="name"
                    rules={[{ required: true, message: "请输入名称" }]}
                >
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
    </div>
}

export default OauthConfig
